module.exports = __webpack_public_path__ + "img/sqzs.f0195d9e.png";